import React, { useMemo } from 'react';
import { safeHTML } from '../../../../utils/safeHTML';
import classNames from 'classnames';
import { useContent } from '../../../../redux/reducer/content';
import { usePrizeInfo } from '../../../../hooks/usePrizeInfo';
import { useTranslation } from '../../../../translations';
import SetsReward from './SetsReward';

const SetsRewards = React.forwardRef(({ gradeData, activeTab, rewards }, ref) => {
  const {
    lootBoxes: { standard, rare },
  } = useContent();
  const { t } = useTranslation();

  const activeLootBox = useMemo(() => (!activeTab ? standard : rare), [activeTab, standard, rare]);

  const { getPrizeType } = usePrizeInfo();

  return (
    <div className={'sets__rewards'}>
      <h3 className={'sets__rewards-title'}>{safeHTML(t(rewards.title))}</h3>
      <ul className={classNames('sets__rewards-list')}>
        {activeLootBox?.prizes
          .filter(({ is_visible }) => is_visible)
          .map((prize, id) => {
            const rewardType = getPrizeType(prize);
            return (
              <SetsReward key={`reward-${id}`} rewardType={rewardType} prize={prize} activeLootBox={activeLootBox} />
            );
          })}
      </ul>
    </div>
  );
});
export default SetsRewards;
SetsRewards.displayName = 'SetsRewards';
SetsRewards.propTypes = {};
